<template>
  <content-nav-bar>
    <template slot="right">
      <a
        @click="internalView = 'tiles'"
        class="level-item">
        <svgicon
          name="querybuilder"
          height="25"
          width="25"
          :class="{ notselected: view !== 'tiles' }">
        </svgicon>
      </a>
      <a
        @click="internalView = 'table'"
        class="level-item">
        <svgicon
          name="textview"
          height="25"
          width="25"
          :class="{ notselected: view !== 'table' }">
        </svgicon>
      </a>
    </template>
    <slot name="first"></slot>
    <a
      v-if="refresh"
      @click="refresh(null)"
      class="level-item">
      <svgicon name="refresh" height="25" width="25"></svgicon>
    </a>
    <slot></slot>
  </content-nav-bar>
</template>

<script>
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'TableTileBar',
  components: { ContentNavBar },
  props: {
    view: {
      type: String,
      required: true,
    },
    refresh: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      internalView: this.view,
    };
  },
  watch: {
    view() {
      this.internalView = this.view;
    },
    internalView() {
      this.$emit('update:view', this.internalView);
    },
  },
};
</script>

<style lang="scss" scoped>
.svg-fill {
  fill: $link-color;
  stroke: none;
}

.svg-fill:hover {
  opacity: 1;
}
</style>
